export { default } from './FeaturesPage'
